import createReducer from "./createReducer";
import { addFiltering } from "./common/Filtering";
import { addColumnFilters } from "./common/ColumnFilters";
import { SUPPRESS_SUCCESS_GROWL } from "utils/constants";

const IMPOSIUM_PROJECT_ACTIONS = {
	CREATE_IMPOSIUM_PROJECT_AJAX: "CREATE_IMPOSIUM_PROJECT_AJAX",
	CREATE_IMPOSIUM_PROJECT_SUCCESS: "CREATE_IMPOSIUM_PROJECT_SUCCESS",
	CREATE_IMPOSIUM_PROJECT_ERROR: "CREATE_IMPOSIUM_PROJECT_ERROR",

	GET_IMPOSIUM_PROJECTS_AJAX: "GET_IMPOSIUM_PROJECTS_AJAX",
	GET_IMPOSIUM_PROJECTS_SUCCESS: "GET_IMPOSIUM_PROJECTS_SUCCESS",
	GET_IMPOSIUM_PROJECTS_ERROR: "GET_IMPOSIUM_PROJECTS_ERROR",

	GET_IMPOSIUM_PROJECT_AJAX: "GET_IMPOSIUM_PROJECT_AJAX",
	GET_IMPOSIUM_PROJECT_SUCCESS: "GET_IMPOSIUM_PROJECT_SUCCESS",
	GET_IMPOSIUM_PROJECT_ERROR: "GET_IMPOSIUM_PROJECT_ERROR",

	CREATE_IMPOSIUM_CREATIVES_AJAX: "CREATE_IMPOSIUM_CREATIVES_AJAX",
	CREATE_IMPOSIUM_CREATIVES_SUCCESS: "CREATE_IMPOSIUM_CREATIVES_SUCCESS",
	CREATE_IMPOSIUM_CREATIVES_ERROR: "CREATE_IMPOSIUM_CREATIVES_ERROR",

	SWITCH_CREATIVE_COMPOSITION_AJAX: "SWITCH_CREATIVE_COMPOSITION_AJAX",
	SWITCH_CREATIVE_COMPOSITION_SUCCESS: "SWITCH_CREATIVE_COMPOSITION_SUCCESS",
	SWITCH_CREATIVE_COMPOSITION_ERROR: "SWITCH_CREATIVE_COMPOSITION_ERROR",

	SET_SELECTED_PROJECT: "SET_SELECTED_PROJECT",
	CLEAR_SELECTED_PROJECT: "CLEAR_SELECTED_PROJECT",

	CLEAR_IMPOSIUM_PROJECTS: "CLEAR_IMPOSIUM_PROJECTS",

	CLEAR_IMPOSIUM_ERRORS: "CLEAR_IMPOSIUM_ERRORS",
};

const initialState={
	items: [],
	totalPages: 1,
	totalItems: 0,
	error: null,
	isLoading: false,
	isLoaded: false,
	isSaving: false,
	selectedProject: null,
};

export function selectProject(id) {
	return (dispatch, getState) => {
		const state = getState();
		const project = state.imposiumProjects.items.find(project => project.id === id) || null;
		return dispatch({
			type: IMPOSIUM_PROJECT_ACTIONS.SET_SELECTED_PROJECT,
			payload: {
				project,
			},
		});
	};
}

export function clearSelectedProject() {
	return (dispatch) => {
		return dispatch({
			type: IMPOSIUM_PROJECT_ACTIONS.CLEAR_SELECTED_PROJECT,
		});
	};
}

export function clearImposiumProjects() {
	return (dispatch) => {
		return dispatch({
			type: IMPOSIUM_PROJECT_ACTIONS.CLEAR_IMPOSIUM_PROJECTS,
		});
	};
}

//expected schema for creatives param is: [{ creativeName: '', compositionId: '' }]
//projectId is aka storyId in imposium
export function addCreativesToImposiumProject(libraryId, projectId, creatives) {
	return (dispatch) => {
		return dispatch({
			type: IMPOSIUM_PROJECT_ACTIONS.CREATE_IMPOSIUM_CREATIVES_AJAX,
			AJAX: {
				method: 'post',
				data: {
					creatives,
				},
				url: `creative-libraries/${libraryId}/imposium/project/${projectId}/vast-creatives`,
				success: IMPOSIUM_PROJECT_ACTIONS.CREATE_IMPOSIUM_CREATIVES_SUCCESS,
				error: IMPOSIUM_PROJECT_ACTIONS.CREATE_IMPOSIUM_CREATIVES_ERROR,
			},
		});
	};
}

export function createImposiumProject(libraryId, data) {
	return (dispatch) => {
		return dispatch({
			type: IMPOSIUM_PROJECT_ACTIONS.CREATE_IMPOSIUM_PROJECT_AJAX,
			AJAX: {
				method: 'post',
				data,
				url: `creative-libraries/${libraryId}/imposium/project`,
				success: IMPOSIUM_PROJECT_ACTIONS.CREATE_IMPOSIUM_PROJECT_SUCCESS,
				error: IMPOSIUM_PROJECT_ACTIONS.CREATE_IMPOSIUM_PROJECT_ERROR,
			},
		});
	};
}


export function getImposiumProjects(libraryId) {
	return (dispatch, getState) => {
		let state = getState();
		let { filterInfo } = state.imposiumProjects || {};
		if(filterInfo) {
			filterInfo.rpp = -1;
		}
		return dispatch({
			type: IMPOSIUM_PROJECT_ACTIONS.GET_IMPOSIUM_PROJECTS_AJAX,
			meta: SUPPRESS_SUCCESS_GROWL,
			AJAX: {
				url: `ui/creative-libraries/${libraryId}/assets`,
				params: {
					...filterInfo,
					advancedFilter: `all(in(assetType,ImposiumProject))`,
				},
				success: IMPOSIUM_PROJECT_ACTIONS.GET_IMPOSIUM_PROJECTS_SUCCESS,
				error: IMPOSIUM_PROJECT_ACTIONS.GET_IMPOSIUM_PROJECTS_ERROR,
			},
		});
	};
}

// Fetches a single project by id, without touching the projects list in state
export function getImposiumProject(libraryId, projectId) {
	return (dispatch) => {
		return dispatch({
			type: IMPOSIUM_PROJECT_ACTIONS.GET_IMPOSIUM_PROJECT_AJAX,
			meta: SUPPRESS_SUCCESS_GROWL,
			AJAX: {
				url: `ui/creative-libraries/${libraryId}/assets`,
				params: {
					advancedFilter: `all(eq(idproject,${projectId}),eq(assetType,ImposiumProject))`,
				},
				success: IMPOSIUM_PROJECT_ACTIONS.GET_IMPOSIUM_PROJECT_SUCCESS,
				error: IMPOSIUM_PROJECT_ACTIONS.GET_IMPOSIUM_PROJECT_ERROR,
			},
		}).then((response) => {
			if(response.success){
				return response.payload?.data?.items?.[0];
			}
		});
	};
}

export function duplicateImposiumProject(libraryId, projectId, newProjectName) {
	const data = {
		imposiumProjects: [
			{
				id: projectId,
				name: newProjectName,
			},
		],
	};
	return (dispatch) => {
		return dispatch({
			type: IMPOSIUM_PROJECT_ACTIONS.CREATE_IMPOSIUM_PROJECT_AJAX,
			meta: SUPPRESS_SUCCESS_GROWL,
			AJAX: {
				method: 'post',
				data,
				url: `creative-libraries/${libraryId}/asset/imposium-project/duplicate`,
				success: IMPOSIUM_PROJECT_ACTIONS.CREATE_IMPOSIUM_PROJECT_SUCCESS,
				error: IMPOSIUM_PROJECT_ACTIONS.CREATE_IMPOSIUM_PROJECT_ERROR,
			},
		});
	};
}

export function clearImposiumErrors() {
	return (dispatch) => {
		return dispatch({
			type: IMPOSIUM_PROJECT_ACTIONS.CLEAR_IMPOSIUM_ERRORS,
		});
	};
}

//this is in the projects reducer instead of the compositions reducer because the project can also be switched
export function switchCreativeComposition(libraryId, creativeId, projectId, compositionId) {
	const data = {
		creativeId,
		projectId,
		compositionId,
	};
	return (dispatch) => {
		return dispatch({
			type: IMPOSIUM_PROJECT_ACTIONS.SWITCH_CREATIVE_COMPOSITION_AJAX,
			AJAX: {
				method: 'put',
				data,
				url: `creative-libraries/${libraryId}/imposium/project/creative`,
				success: IMPOSIUM_PROJECT_ACTIONS.SWITCH_CREATIVE_COMPOSITION_SUCCESS,
				error: IMPOSIUM_PROJECT_ACTIONS.SWITCH_CREATIVE_COMPOSITION_ERROR,
			},
		});
	};
}


export const handlers={
	[IMPOSIUM_PROJECT_ACTIONS.CREATE_IMPOSIUM_PROJECT_AJAX] :createImposiumProjectRequest,
	[IMPOSIUM_PROJECT_ACTIONS.CREATE_IMPOSIUM_PROJECT_SUCCESS] :createImposiumProjectSuccess,
	[IMPOSIUM_PROJECT_ACTIONS.CREATE_IMPOSIUM_PROJECT_ERROR] :createImposiumProjectError,

	[IMPOSIUM_PROJECT_ACTIONS.GET_IMPOSIUM_PROJECTS_AJAX] :getImposiumProjectsRequest,
	[IMPOSIUM_PROJECT_ACTIONS.GET_IMPOSIUM_PROJECTS_SUCCESS] :getImposiumProjectsSuccess,
	[IMPOSIUM_PROJECT_ACTIONS.GET_IMPOSIUM_PROJECTS_ERROR] :getImposiumProjectsError,

	[IMPOSIUM_PROJECT_ACTIONS.CREATE_IMPOSIUM_CREATIVES_AJAX]: createCreativesRequest,
	[IMPOSIUM_PROJECT_ACTIONS.CREATE_IMPOSIUM_CREATIVES_SUCCESS]: createCreativesSuccess,
	[IMPOSIUM_PROJECT_ACTIONS.CREATE_IMPOSIUM_CREATIVES_ERROR]: createCreativesError,

	[IMPOSIUM_PROJECT_ACTIONS.SWITCH_CREATIVE_COMPOSITION_AJAX]: switchCompositionRequest,
	[IMPOSIUM_PROJECT_ACTIONS.SWITCH_CREATIVE_COMPOSITION_SUCCESS]: switchCompositionSuccess,
	[IMPOSIUM_PROJECT_ACTIONS.SWITCH_CREATIVE_COMPOSITION_ERROR]: switchCompositionError,

	[IMPOSIUM_PROJECT_ACTIONS.SET_SELECTED_PROJECT] :setProject,
	[IMPOSIUM_PROJECT_ACTIONS.CLEAR_SELECTED_PROJECT] :resetProject,

	[IMPOSIUM_PROJECT_ACTIONS.CLEAR_IMPOSIUM_PROJECTS] :resetImposiumProjects,

	[IMPOSIUM_PROJECT_ACTIONS.CLEAR_IMPOSIUM_ERRORS] :clearErrors,
};

function createImposiumProjectRequest(state, action) {
	return {
		...state,
		isSaving: true,
	};
}

function createImposiumProjectSuccess(state, action) {
	return {
		...state,
		isSaving: false,
	};
}

function createImposiumProjectError(state, action) {
	return {
		...state,
		isSaving: false,
		error: action.payload.errorObj,
	};
}

function createCreativesRequest(state, action) {
	return {
		...state,
		isSaving: true,
	};
}

function createCreativesSuccess(state, action) {
	return {
		...state,
		isSaving: false,
	};
}

function createCreativesError(state, action) {
	return {
		...state,
		isSaving: false,
		error: action.payload.errorObj,
	};
}

function switchCompositionRequest(state, action) {
	return {
		...state,
		isSaving: true,
	};
}

function switchCompositionSuccess(state, action) {
	return {
		...state,
		isSaving: false,
	};
}

function switchCompositionError(state, action) {
	return {
		...state,
		isSaving: false,
		error: action.payload.errorObj || { description: 'An error occurred while attempting to switch composition' },
	};
}

function getImposiumProjectsRequest(state, action) {
	return {
		...state,
		isLoading: true,
		isLoaded: false,
	};
}

function getImposiumProjectsSuccess(state, action) {
	return {
		...state,
		items: action.payload?.data?.items || [],
		totalItems: action.payload?.data?.totalItems || 0,
		totalPages: action.payload?.data?.totalPages || 1,
		isLoading: false,
		isLoaded: true,
	};
}

function getImposiumProjectsError(state, action) {
	return {
		...state,
		isLoading: false,
		isLoaded: false,
		error: action.payload.errorObj,
	};
}

function clearErrors(state, action) {
	return {
		...state,
		error: null,
	};
}

function setProject(state, action) {
	return {
		...state,
		selectedProject: action.payload.project,
	};
}

function resetProject(state, action) {
	return {
		...state,
		selectedProject: null,
	};
}

function resetImposiumProjects(state, action) {
	return {
		...initialState,
		filterInfo: state.filterInfo, // preserve filters
	};
}

let reducerConfig = {
	typeRoot: "IMPOSIUM_PROJECTS",
	actionTypes: IMPOSIUM_PROJECT_ACTIONS,
	actionCreators: {
		selectProject,
		clearSelectedProject,
		addCreativesToImposiumProject,
		createImposiumProject,
		getImposiumProjects,
		getImposiumProject,
		clearImposiumErrors,
		switchCreativeComposition,
		duplicateImposiumProject,
	},
	initialState,
	handlers,
};

reducerConfig = addFiltering(reducerConfig, {});
reducerConfig = addColumnFilters(reducerConfig, {});

export default createReducer(reducerConfig.initialState, reducerConfig.handlers);
export const ImposiumProjects = reducerConfig.actionCreators;
